import React from 'react';
import {FaClipboardCheck} from "react-icons/fa";
import {FaLocationPin} from "react-icons/fa6";
import DivisorItem from "./divisor-item.jsx";
import {navigateHook} from "../../../../../../../hooks/use-navigate.js";
import Button from "../../../../../../../components/button/button.jsx"
import CheckHasData from "../../check-has-data.jsx";

const SosDetails = ({data}) => {
    const navigate = navigateHook();

    const open = () => {
        const urlDev = `/sos/citizen/${data.id}`
        navigate(urlDev, true);
    }

    return (
        <>
            <p className={`text-[16px] font-bold text-white p-2 bg-[#ffb947] mb-0`}>
                <CheckHasData value={data?.protections.map(p => p).join(", ") || ""} />
            </p>
            <div className={"p-2"}>
                <DivisorItem icon={<FaClipboardCheck size={18}/>} text={"Situação"} value={data.status}/>
                <DivisorItem icon={<FaLocationPin size={18}/>} text={"Endereço"} value={data.address}/>

                <Button variant="primary" onClick={open}>
                    Abrir cadastro
                </Button>
            </div>
        </>
    )
};

export default SosDetails;